<template>
  <v-menu
    transition="slide-y-transition"
    :close-on-content-click="true"
    offset-y
    content-class="oms-notification-menu"
    class="oms-notification-tray profile-drop"
  >
    <v-toolbar-side-icon slot="activator" class="oms-notification-trigger">
      <v-icon @click="getNotifications()">notifications</v-icon>
    </v-toolbar-side-icon>
    <v-card class="oms-notification-card">
      <header class="oms-notification-header">
        <div class="oms-notification-header__brand">
          <div class="oms-notification-header__badge" aria-hidden="true">
            <v-icon>notifications</v-icon>
          </div>
          <div class="oms-notification-header__copy">
            <h2 class="oms-notification-title">Notifications</h2>
            <p class="oms-notification-subtitle">{{ unreadLabel }}</p>
          </div>
        </div>
        <div class="oms-notification-header__actions">
          <button
            type="button"
            class="oms-notification-mark-all"
            :disabled="!count || count == 0"
            @click="markAllRead($event)"
          >
            Mark all read
          </button>
          <router-link class="oms-notification-view-all" to="/notifications">
            View all
          </router-link>
        </div>
      </header>

      <v-list class="oms-notification-list scroll" v-if="notificationListing.length">
        <v-list-tile
          class="text-overlap list-noti oms-notification-item"
          :class="{ 'oms-notification-item--unread': !item.isRead }"
          v-for="item in notificationListing"
          @click="!item.isRead ? markRead(item, $event) : ''"
          :key="item._id"
        >
          <div class="oms-notification-item__inner">
            <span
              class="oms-notification-dot"
              :class="{ 'oms-notification-dot--hidden': item.isRead }"
              aria-hidden="true"
            ></span>
            <div class="oms-notification-item__content">

          <v-list-tile-title
            v-if="item.type == 1"
            @click="checkViewJob(item.jobData.jobId)"
            target="_blank"
            class="line-height-set"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span v-if="item.senderdData"
                >Added by: {{ item.senderdData.name }}</span
              >
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            v-else-if="item.type == 4"
            style="cursor: pointer"
            @click="checkTender(item.jobData.jobModel)"
            class="line-height-set"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>

          <v-list-tile-title
            v-else-if="item.type == 33"
            @click="redirectCustomerReciept()"
            style="cursor: pointer"
            class="line-height-set"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>

          <v-list-tile-title
            @click="redirectApproval('sales')"
            target="_blank"
            style="cursor: pointer"
            class="line-height-set cursor"
            v-else-if="item.type == 3"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectNotification('procurements')"
            target="_blank"
            style="cursor: pointer"
            class="line-height-set cursor"
            v-else-if="item.type == 8"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectNotification('request-callback')"
            style="cursor: pointer; height: auto !important"
            class="line-height-set cursor"
            v-else-if="item.type == 9"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right"> {{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectApproval('job')"
            target="_blank"
            style="cursor: pointer"
            class="line-height-set cursor"
            v-else-if="item.type == 2"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="
              redirectTransDriver(
                item.transporterData.transporterId,
                item.transporterData._id,
                item.workingCountry
              )
            "
            target="_blank"
            style="cursor: pointer"
            class="line-height-set cursor"
            v-else-if="item.type == 7"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectjobDetail(item.jobData.jobId)"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 10"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectNotification('transporter')"
            target="_blank"
            style="cursor: pointer"
            class="line-height-set cursor"
            v-else-if="item.type == 11"
          >
            <p class="gray-dark">{{ item.message }}</p>

            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts2()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 12"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectassignmentview()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 13"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 17"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 14"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectCustomers()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 18"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectNotification('sales')"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 19"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectNotification('sales')"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 22"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectDrivers()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 23"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectCustomers()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 21"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectjobs()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 24"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts2()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 25"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts2()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 26"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="
              redirectAccountsDriver(
                item.assignmentIdNumber,
                item.workingCountry
              )
            "
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 27"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="
              redirectAccountsDriver(
                item.assignmentIdNumber,
                item.workingCountry
              )
            "
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 32"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectjobs()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 28"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectAccounts2()"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 29"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
          <v-list-tile-title
            @click="redirectProof(item.assignmentId)"
            target="_blank"
            class="line-height-set cursor"
            v-else-if="item.type == 30"
            style="cursor: pointer"
          >
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>

          <v-list-tile-title class="line-height-set" v-else>
            <p class="gray-dark">{{ item.message }}</p>
            <p class="tag-gray d-flex justify-content-between">
              <span></span>
              <span class="text-right">{{ getUtcTime(item.createdAt) }}</span>
            </p>
          </v-list-tile-title>
            </div>
          </div>
        </v-list-tile>
      </v-list>
      <div v-else class="oms-notification-empty">
        <div class="oms-notification-empty__icon" aria-hidden="true">
          <v-icon>notifications_none</v-icon>
        </div>
        <p class="oms-notification-empty__title">You're all caught up</p>
        <p class="oms-notification-empty__copy">No new notifications right now.</p>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { StorageKeys } from "../../constants/constants";
import moment from "moment";
import { notificationList } from "@/constants/api-urls.js";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
export default {
  data() {
    return {
      opeartionName: "",
      operationName1: "",
      notificationListing: [],
      workingCountries: [],
      workingCountry: [],
      btnValue: true,
      shown: false,
    };
  },
  watch: {},
  created() {
    this.$eventBus.$on("notify", (val) => {
      if (
        this.notificationListing.length &&
        this.$route.name != "notifications" &&
        this.shown
      ) {
        this.getNotifications();
      }
    });
  },
  props: {
    selectedCountry: Array,
    jobCommentsUEA: Number,
    jobCommentsKSA: Number,
    jobCommentsPAK: Number,
    jobCommentsUAELA: Number,
    count: Number,
  },
  computed: {
    unreadLabel() {
      const n = Number(this.count) || 0;
      if (n <= 0) return "No unread alerts";
      if (n === 1) return "1 unread alert";
      if (n > 99) return "99+ unread alerts";
      return `${n} unread alerts`;
    },
  },

  methods: {
    redirectProof(id) {
      this.$router.push(`/documents/${id}?type=Driver_Proof`);
    },
    async checkViewJob(jobId) {
      this.operationName = "view-details-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.$eventBus.$emit("view-details", true);
        this.$router.push(`/jobs/${jobId.toString()}/view`);
        this.$eventBus.$emit("refresh-job");
      } else {
        return;
      }
    },
    redirectAccounts2() {
      this.$router.push(`/accounts/advance`).catch(() => {});
    },
    redirectjobs() {
      this.$router.push(`/assignments`);
    },
    redirectassignmentview(transporterId) {
      this.$router.push(`/assignments/`).catch(() => {});
    },
    redirectApproval(type) {
      this.$router.push(`/approvals?type=${type}`).catch(() => {});
    },
    redirectCustomerReciept() {
      this.$router.push(`/accounts/customerPayment`).catch(() => {});
    },
    redirectjobDetail(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    redirectDrivers() {
      this.$router.push(`/drivers`);
    },
    redirectAccounts() {
      this.$router.push(`/accounts`);
    },
    redirectAccountsDriver(assignmentId, workingCountry) {
      this.$router
        .push(
          `/accounts/advance?type=${assignmentId}&country=${workingCountry}`
        )
        .catch(() => {});
    },

    redirectCustomers() {
      this.$router.push(`/customers?type=false`);
    },
    redirectDrivers() {
      this.$router.push(`/drivers`);
    },
    redirectTransDriver(transporterId, _id, workingCountry) {
      this.$router.push(
        `/transporter/driver/${transporterId}/${_id}/${workingCountry}`
      );
    },
    async checkTender(model) {
      this.$router.push(`/tender/${model}`);
    },
    redirectNotification(type) {
      this.$router.push(`/${type}`);
    },
    getUtcTime(date) {
      return moment(date).format(" ll LT");
    },

    markAllRead(e) {
      e.stopPropagation();
      let url = `/commentRoute/v1/readNotification`;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      if (localStorage.getItem("workingCountries")) {
        this.workingCountry = [];
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry.push(key.value);
          }
        });
      }
      let body = {
        workingCountry: this.workingCountry,
        isReadAll: true,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.data.data) {
            this.getNotifications();
          }
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
    markRead(data) {
      let url = `/commentRoute/v1/readNotification`;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      if (localStorage.getItem("workingCountries")) {
        this.workingCountry = [];
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry.push(key.value);
          }
        });
      }
      let body = {
        workingCountry: this.workingCountry,
        _id: data._id,
        isReadAll: false,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.data.data) {
            this.getNotifications();
          }
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
    getNotifications() {
      setTimeout(() => {
        var objDiv = document.getElementsByClassName("scroll");
        for (var i = 0; i < objDiv.length; i++) {
          objDiv[i].scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      }, 1000);

      this.$emit("unread-count");
      this.shown = true;
      this.closeOnContentClick = false;
      let url = notificationList;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      if (localStorage.getItem("workingCountries")) {
        this.workingCountry = [];
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry.push(key.value);
          }
        });
      }

      let body = {
        workingCountry: this.workingCountry,
        pageNo: "1",
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          if (response.data.data) {
            this.$emit("removeDot");
            this.notificationListing = response.data.data.list;
            this.notificationListing;
          }
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
  },
};
</script>
<style lang="scss">
.menuable__content__active.oms-notification-menu,
.oms-notification-menu {
  border-radius: 0.875rem !important;
  box-shadow: 0 1rem 2rem rgba(28, 43, 95, 0.16) !important;
  margin-top: 0.4rem !important;
  max-width: min(24.5rem, calc(100vw - 1.25rem)) !important;
  overflow: hidden !important;
  width: min(24.5rem, calc(100vw - 1.25rem)) !important;
}

.oms-notification-menu .oms-notification-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 0.875rem !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  max-height: min(68vh, 30rem);
  overflow: hidden;
  width: 100%;
}

.oms-notification-header {
  align-items: center;
  background: #ffffff;
  border-bottom: 0.0625rem solid #ebe9e2;
  display: flex;
  gap: 0.65rem;
  justify-content: space-between;
  padding: 0.7rem 0.85rem;
}

.oms-notification-header__brand {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  gap: 0.6rem;
  min-width: 0;
}

.oms-notification-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.55rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.oms-notification-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 0.95rem !important;
}

.oms-notification-header__copy {
  min-width: 0;
}

.oms-notification-title {
  color: #1c2b5f;
  font-size: 0.9375rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.oms-notification-subtitle {
  color: #c35f02;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0.1rem 0 0;
}

.oms-notification-header__actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 0.4rem;
}

.oms-notification-view-all {
  color: #1c2b5f !important;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  padding: 0.2rem 0.15rem;
  text-decoration: none;
  text-transform: none;
  white-space: nowrap;
}

.oms-notification-view-all:hover,
.oms-notification-view-all:focus {
  color: #ea7a1c !important;
  text-decoration: none;
}

.oms-notification-mark-all {
  align-items: center;
  background: #ea7a1c;
  border: 0;
  border-radius: 0.4rem;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  min-height: 1.7rem;
  padding: 0.2rem 0.55rem;
  text-transform: none;
  white-space: nowrap;
}

.oms-notification-mark-all:hover:not(:disabled),
.oms-notification-mark-all:focus:not(:disabled) {
  background: #d96a10;
}

.oms-notification-mark-all:disabled {
  background: #f3f1eb;
  color: #9e9a91;
  cursor: not-allowed;
}

.oms-notification-menu .oms-notification-list.scroll,
.oms-notification-menu .scroll {
  background: #ffffff !important;
  flex: 1 1 auto;
  height: auto !important;
  max-height: min(56vh, 24rem);
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding: 0 !important;
  scrollbar-color: #c9c5bd transparent;
  scrollbar-width: thin;
}

.oms-notification-menu .oms-notification-list.scroll::-webkit-scrollbar {
  width: 0.25rem;
}

.oms-notification-menu .oms-notification-list.scroll::-webkit-scrollbar-track {
  background: transparent;
}

.oms-notification-menu .oms-notification-list.scroll::-webkit-scrollbar-thumb {
  background: #c9c5bd;
  border-radius: 999px;
}

.oms-notification-menu .list-noti.oms-notification-item {
  background: #ffffff !important;
  border: 0 !important;
  border-bottom: 0.0625rem solid #f0eee8 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  transition: background 0.14s ease;
}

.oms-notification-menu .list-noti.oms-notification-item:last-child {
  border-bottom: 0 !important;
}

.oms-notification-menu .list-noti.oms-notification-item:hover,
.oms-notification-menu .list-noti.oms-notification-item--unread:hover {
  background: #faf9f6 !important;
  border-color: #f0eee8 !important;
  box-shadow: none !important;
}

.oms-notification-menu .list-noti.oms-notification-item--unread {
  background: #ffffff !important;
}

.oms-notification-menu .list-noti.oms-notification-item--unread::before {
  display: none !important;
}

.oms-notification-menu .oms-notification-item .v-list__tile {
  align-items: stretch !important;
  display: block !important;
  height: auto !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.oms-notification-item__inner {
  align-items: flex-start;
  display: flex;
  gap: 0.65rem;
  padding: 0.75rem 0.9rem;
  width: 100%;
}

.oms-notification-item__content {
  flex: 1 1 auto;
  min-width: 0;
}

.oms-notification-menu .oms-notification-item .v-list__tile__title,
.oms-notification-menu .oms-notification-item .line-height-set {
  height: auto !important;
  max-width: 100%;
  overflow: visible !important;
  text-overflow: unset !important;
  white-space: normal !important;
}

.oms-notification-dot {
  background: #ea7a1c;
  border-radius: 999px;
  flex: 0 0 auto;
  height: 0.4rem;
  margin-top: 0.4rem;
  width: 0.4rem;
}

.oms-notification-dot--hidden {
  background: transparent;
  box-shadow: none;
}

.oms-notification-menu .gray-dark {
  color: #1c2b5f !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  margin: 0 0 0.35rem !important;
  word-break: break-word;
}

.oms-notification-menu .tag-gray {
  align-items: flex-start !important;
  color: #8a857c !important;
  display: flex !important;
  flex-wrap: wrap;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  gap: 0.25rem 0.65rem;
  justify-content: space-between !important;
  line-height: 1.35 !important;
  margin: 0 !important;
  width: 100%;
}

.oms-notification-menu .tag-gray .text-right {
  color: #9e9a91 !important;
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
  margin-left: auto;
  text-align: right;
  white-space: nowrap;
}

.oms-notification-empty {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  justify-content: center;
  padding: 1.75rem 1rem;
  text-align: center;
}

.oms-notification-empty__icon {
  align-items: center;
  background: #faf9f6;
  border: 0.0625rem solid #ebe9e2;
  border-radius: 999px;
  display: inline-flex;
  height: 2.25rem;
  justify-content: center;
  margin-bottom: 0.35rem;
  width: 2.25rem;
}

.oms-notification-empty__icon .v-icon {
  color: #ea7a1c !important;
  font-size: 1.1rem !important;
}

.oms-notification-empty__title {
  color: #1c2b5f;
  font-size: 0.8125rem;
  font-weight: 800;
  margin: 0;
}

.oms-notification-empty__copy {
  color: #8a857c;
  font-size: 0.6875rem;
  font-weight: 600;
  margin: 0;
}

.text-overlap .v-list__tile {
  height: auto !important;
}
</style>

<style scoped>
.text-right {
  text-align: right;
}
</style>
